<template>
  <v-app class="homesync-landing">
    <!-- Header Navigation -->
    <v-app-bar
      elevation="0"
      :color="scrolled ? 'rgba(255, 255, 255, 0.98)' : 'transparent'"
      fixed
      class="homesync-header"
      :class="{ 'scrolled': scrolled }"
    >
      <v-container fluid class="px-md-8">
        <v-row align="center" justify="space-between" no-gutters>
          <!-- Logo -->
          <v-col cols="auto">
            <div class="logo-container d-flex align-center">
              <img
                src="@/assets/img/logo.png"
                alt="HomeSyncX™️"
                class="homesync-logo"
                :height="$vuetify.breakpoint.xs ? 65 : 90"
              />
            </div>
          </v-col>

          <!-- Desktop Navigation -->
          <v-col cols="auto" v-if="$vuetify.breakpoint.mdAndUp">
            <div class="nav-links d-flex align-center">
              <v-btn text :color="scrolled ? '#1a1a2e' : 'white'" class="nav-link px-4" @click="scrollToSection('about')">
                About
              </v-btn>
              <v-btn text :color="scrolled ? '#1a1a2e' : 'white'" class="nav-link px-4" @click="scrollToSection('how-it-works')">
                How It Works
              </v-btn>
              <v-btn text :color="scrolled ? '#1a1a2e' : 'white'" class="nav-link px-4" @click="scrollToSection('partner')">
                Partners
              </v-btn>
              <v-btn
                outlined
                :color="scrolled ? '#0052CC' : 'white'"
                class="login-btn ml-4"
                @click="goToLogin"
              >
                Login
              </v-btn>
              <v-btn
                depressed
                color="#0052CC"
                dark
                class="signup-btn ml-3"
                @click="joinFree"
              >
                Get Started
              </v-btn>
            </div>
          </v-col>

          <!-- Mobile Menu -->
          <v-col cols="auto" v-else>
            <v-app-bar-nav-icon
              :color="scrolled ? '#1a1a2e' : 'white'"
              @click="drawer = !drawer"
            ></v-app-bar-nav-icon>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <!-- Mobile Navigation Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
      width="280"
      class="mobile-drawer"
    >
      <v-list class="pt-8">
        <v-list-item @click="scrollToSection('about'); drawer = false">
          <v-list-item-icon>
            <i class="material-icons-round">info</i>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">About</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="scrollToSection('how-it-works'); drawer = false">
          <v-list-item-icon>
            <i class="material-icons-round">lightbulb</i>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">How It Works</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="scrollToSection('partner'); drawer = false">
          <v-list-item-icon>
            <i class="material-icons-round">handshake</i>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Partners</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-4"></v-divider>

        <v-list-item @click="goToLogin(); drawer = false">
          <v-list-item-icon>
            <i class="material-icons-round">login</i>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Login</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="mt-4">
          <v-btn
            block
            large
            color="#0052CC"
            dark
            elevation="0"
            @click="joinFree(); drawer = false"
          >
            Get Started
          </v-btn>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

      
    <v-main class="auth-pages dealer-main-content">
      <!-- Hero Section -->
      <section class="hero-section">
        <div class="hero-background">
        
          <v-container fluid class="dashboard-container">
            <v-row align="center" justify="center">
              <v-col cols="12" md="10" lg="9" xl="8">
                <div class="text-center">
      

                  <!-- Main Headline -->
                  <h1 class="hero-title mb-6" data-aos="fade-up" data-aos-delay="100">
                    Own Your Leads. Build Your Legacy.<br class="d-none d-sm-block">
                    Welcome to HomeSyncX.
                  </h1>

                  <!-- Subheadline -->
                  <p class="hero-subtitle mb-8" data-aos="fade-up" data-aos-delay="200">
                    The all-in-one referral network for real estate pros who want<br class="d-none d-md-block">
                    to close faster, automate everything, and earn more with shared commissions.
                  </p>

                  <!-- CTA Buttons -->
                  <div class="hero-buttons mb-8" data-aos="fade-up" data-aos-delay="300">
                    <v-btn
                      x-large
                      color="#0052CC"
                      dark
                      elevation="8"
                      class="join-btn mr-md-4 mb-3 mb-md-0"
                      @click="joinFree"
                    >
                      <i class="material-icons-round mr-2">rocket_launch</i>
                    Join Free
                    </v-btn>
                    <v-btn
                      x-large
                      color="yellow"
                      class="how-btn"
                      @click="scrollToSection('how-it-works')"
                    >
                      <i class="material-icons-round mr-2">play_circle</i>
                      How It Works
                    </v-btn>
                  </div>

                  <!-- Trust Indicators -->
                  <div class="trust-indicators" data-aos="fade-up" data-aos-delay="400">
                    <div class="trust-item">
                      <div class="trust-number">10K+</div>
                      <div class="trust-label">Active Agents</div>
                    </div>
                    <div class="trust-divider"></div>
                    <div class="trust-item">
                      <div class="trust-number">$2.5B+</div>
                      <div class="trust-label">Properties Sold</div>
                    </div>
                    <div class="trust-divider"></div>
                    <div class="trust-item">
                      <div class="trust-number">98%</div>
                      <div class="trust-label">Satisfaction Rate</div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </section>

      <!-- How It Works Section -->
      <section id="how-it-works" class="how-it-works-section">
        <v-container>
          <v-row justify="center" class="mb-12">
            <v-col cols="12" md="10" lg="8" class="text-center">
              <div class="section-badge mb-4" data-aos="fade-up">
                <i class="material-icons-round mr-2">auto_awesome</i>
                Simple Process
              </div>
              <h2 class="section-title mb-4" data-aos="fade-up" data-aos-delay="100">
                How HomeSyncX™️ Works
              </h2>
              <p class="section-subtitle" data-aos="fade-up" data-aos-delay="200">
                Get started in minutes and start earning commissions on every referral
              </p>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="4"
              v-for="(step, index) in steps"
              :key="index"
            >
              <div
                class="step-card"
                data-aos="fade-up"
                :data-aos-delay="index * 150"
              >
                <div class="step-icon-wrapper">
                  <div class="step-number-badge">{{ step.number }}</div>
                  <div class="step-icon-circle">
                    <i class="material-icons-round">{{ step.icon }}</i>
                  </div>
                </div>
                <h3 class="step-title">{{ step.title }}</h3>
                <p class="step-description">{{ step.description }}</p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <!-- Features Section -->
      <section id="about" class="features-section">
        <v-container>
          <v-row justify="center" class="mb-12">
            <v-col cols="12" md="10" lg="8" class="text-center">
              <div class="section-badge mb-4" data-aos="fade-up">
                <i class="material-icons-round mr-2">stars</i>
                Powerful Features
              </div>
              <h2 class="section-title mb-4" data-aos="fade-up" data-aos-delay="100">
                Everything You Need to Succeed
              </h2>
              <p class="section-subtitle" data-aos="fade-up" data-aos-delay="200">
                Built for real estate professionals who demand excellence
              </p>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              sm="6"
              lg="3"
              v-for="(feature, index) in features"
              :key="index"
            >
              <div
                class="feature-card"
                data-aos="fade-up"
                :data-aos-delay="index * 100"
              >
                <div class="feature-icon-wrapper">
                  <i class="material-icons-round">{{ feature.icon }}</i>
                </div>
                <h3 class="feature-title">{{ feature.title }}</h3>
                <p class="feature-description">{{ feature.description }}</p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <!-- For Real Estate Agents Section -->
      <section class="agents-section">
        <v-container>
          <v-row align="center">
            <v-col cols="12" md="6" order="2" order-md="1" data-aos="fade-right">
              <div class="content-image-wrapper">
                <div class="image-decoration"></div>
                <div class="stats-card">
                  <div class="stat-item">
                    <div class="stat-icon">
                      <i class="material-icons-round">trending_up</i>
                    </div>
                    <div class="stat-content">
                      <div class="stat-value">156%</div>
                      <div class="stat-label">Avg. Revenue Increase</div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6" order="1" order-md="2" data-aos="fade-left">
              <div class="section-badge mb-4">
                <i class="material-icons-round mr-2">real_estate_agent</i>
                For Agents
              </div>
              <h2 class="section-title-left mb-4">
                Keep Your Leads.<br>Automate Your Success.
              </h2>
              <p class="section-description mb-6">
                HomeSyncX™️ empowers real estate agents to brand themselves, manage referrals effortlessly,
                and never lose track of a deal. Our AI-powered platform handles the heavy lifting while you
                focus on closing.
              </p>
              <ul class="feature-list">
                <li>
                  <i class="material-icons-round">check_circle</i>
                  <span>Personalized agent profile & referral link</span>
                </li>
                <li>
                  <i class="material-icons-round">check_circle</i>
                  <span>Automated follow-up sequences</span>
                </li>
                <li>
                  <i class="material-icons-round">check_circle</i>
                  <span>Real-time deal tracking dashboard</span>
                </li>
                <li>
                  <i class="material-icons-round">check_circle</i>
                  <span>Commission transparency & instant payouts</span>
                </li>
              </ul>
              <v-btn
                large
                color="#0052CC"
                dark
                elevation="0"
                class="mt-6"
                @click="joinFree"
              >
                Join as Agent
                <i class="material-icons-round ml-2">arrow_forward</i>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <!-- For Investors & Partners Section -->
      <section id="partner" class="partners-section">
        <v-container>
          <v-row align="center">
            <v-col cols="12" md="6" data-aos="fade-right">
              <div class="section-badge mb-4">
                <i class="material-icons-round mr-2">handshake</i>
                For Partners
              </div>
              <h2 class="section-title-left mb-4">
                Scale Your Business.<br>Multiply Your Reach.
              </h2>
              <p class="section-description mb-6">
                Get access to a verified network of top-performing agents, real-time market data,
                and co-branding opportunities for property launches. Perfect for investors, brokers,
                and development partners.
              </p>
              <ul class="feature-list">
                <li>
                  <i class="material-icons-round">check_circle</i>
                  <span>Access to 10,000+ verified agents</span>
                </li>
                <li>
                  <i class="material-icons-round">check_circle</i>
                  <span>Real-time market analytics & insights</span>
                </li>
                <li>
                  <i class="material-icons-round">check_circle</i>
                  <span>Co-branded marketing campaigns</span>
                </li>
                <li>
                  <i class="material-icons-round">check_circle</i>
                  <span>Priority listing distribution</span>
                </li>
              </ul>
              <v-btn
                large
                outlined
                color="#0052CC"
                class="mt-6"
                @click="scrollToSection('join')"
              >
                Become a Partner
                <i class="material-icons-round ml-2">arrow_forward</i>
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" data-aos="fade-left">
              <div class="content-image-wrapper partner-image">
                <div class="image-decoration partner-decoration"></div>
                <div class="stats-card partner-stats">
                  <div class="stat-item">
                    <div class="stat-icon">
                      <i class="material-icons-round">groups</i>
                    </div>
                    <div class="stat-content">
                      <div class="stat-value">10K+</div>
                      <div class="stat-label">Partner Network</div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <!-- Call to Action Section -->
      <section id="join" class="cta-section">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" md="10" lg="8">
              <div class="cta-card" data-aos="zoom-in">
                <div class="cta-content text-center">
                  <div class="cta-icon mb-4">
                    <i class="material-icons-round">rocket_launch</i>
                  </div>
                  <h2 class="cta-title mb-4">
                    Ready to build your real-estate network?
                  </h2>
                  <p class="cta-subtitle mb-8">
                    Join thousands of agents and partners already growing their business with HomeSyncX™️.<br class="d-none d-md-block">
                    Get your personalized agent card and start earning today.
                  </p>
                  <div class="cta-buttons">
                    <v-btn
                      x-large
                      color="yellow"
                      class="cta-btn primary-cta"
                      elevation="0"
                      @click="createAccount"
                    >
                      <i class="material-icons-round mr-2">person_add</i>
                      Create My Account
                    </v-btn>
                    <v-btn
                      x-large
                      outlined
                      color="white"
                      dark
                      class="cta-btn secondary-cta ml-md-4 mt-3 mt-md-0"
                      @click="scrollToSection('how-it-works')"
                    >
                      <i class="material-icons-round mr-2">help_outline</i>
                      Learn More
                    </v-btn>
                  </div>

                  <!-- Trust Badges -->
                  <div class="cta-trust-badges mt-8">
                    <div class="trust-badge">
                      <i class="material-icons-round">verified_user</i>
                      <span>Secure & Encrypted</span>
                    </div>
                    <div class="trust-badge">
                      <i class="material-icons-round">credit_card_off</i>
                      <span>No Credit Card Required</span>
                    </div>
                    <div class="trust-badge">
                      <i class="material-icons-round">schedule</i>
                      <span>Setup in 2 Minutes</span>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <!-- Footer -->
      <footer class="homesync-footer">
        <v-container>
          <v-row class="py-8">
            <v-col cols="12" md="4" class="mb-6 mb-md-0">
              <img
                src="@/assets/img/logo.png"
                alt="HomeSyncX™️"
                height="50"
                class="mb-4"
              />
              <p class="footer-description">
                The intelligent referral network for real estate professionals.
                Powered by AI, built for success.
              </p>
              
            </v-col>

            <v-col cols="6" md="2" class="mb-6 mb-md-0">
              <h4 class="footer-heading mb-4">Product</h4>
              <ul class="footer-menu">
                <li><a href="#" @click.prevent="scrollToSection('about')">Features</a></li>
                <li><a href="#" @click.prevent="scrollToSection('how-it-works')">How It Works</a></li>
                <li><a href="#" @click.prevent="scrollToSection('partner')">Partners</a></li>
                <li><a href="#" @click.prevent="joinFree">Pricing</a></li>
              </ul>
            </v-col>

            <v-col cols="6" md="2" class="mb-6 mb-md-0">
              <h4 class="footer-heading mb-4">Company</h4>
              <ul class="footer-menu">
                <li><a href="#">About Us</a></li>
                <li><a href="#">Careers</a></li>
                <li><a href="#">Blog</a></li>
                <li><a href="#">Contact</a></li>
              </ul>
            </v-col>

           

            <v-col cols="6" md="2">
              <h4 class="footer-heading mb-4">Legal</h4>
              <ul class="footer-menu">
                <li><router-link to="/terms-and-conditions">Privacy Policy</router-link></li>
                <li><router-link to="/terms-and-conditions">Terms of Service</router-link></li>
                <li><router-link to="/cookie-policy">Cookie Policy</router-link></li>
                <li><router-link to="/compliance">Compliance</router-link></li>
              </ul>
            </v-col>
          </v-row>

          <v-divider class="my-6" dark></v-divider>

          <v-row>
            <v-col cols="12" class="text-center">
              <p class="footer-copyright">
                © {{ new Date().getFullYear() }} HomeSyncX™️. All rights reserved.
                Built with <i class="material-icons-round heart-icon">favorite</i> for real estate professionals.
              </p>
            </v-col>
          </v-row>
        </v-container>
      </footer>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'HomeSyncLanding',
  data() {
    return {
      drawer: false,
      scrolled: false,
      steps: [
        {
          number: 1,
          icon: 'person_add',
          title: 'Sign Up Free',
          description: 'Create your agent profile in minutes and get your personalized referral link instantly.'
        },
        {
          number: 2,
          icon: 'share',
          title: 'Share & Earn',
          description: 'Share your link with buyers, sellers, and investors. Earn on every successful referral.'
        },
        {
          number: 3,
          icon: 'analytics',
          title: 'Track & Grow',
          description: 'Monitor all deals, commissions, and payouts in real-time from your dashboard.'
        }
      ],
      features: [
        {
          icon: 'psychology',
          title: 'AI-Powered Insights',
          description: 'Get intelligent recommendations and market predictions to close deals faster.'
        },
        {
          icon: 'auto_awesome',
          title: 'Smart Automation',
          description: 'Automate follow-ups, scheduling, and client communications effortlessly.'
        },
        {
          icon: 'account_balance_wallet',
          title: 'Instant Payouts',
          description: 'Receive your commissions instantly with full transparency and tracking.'
        },
        {
          icon: 'verified',
          title: 'Verified Network',
          description: 'Connect with pre-screened, top-performing agents and trusted partners.'
        },
        {
          icon: 'dashboard_customize',
          title: 'Custom Branding',
          description: 'Personalize your agent card and profile to match your unique brand.'
        },
        {
          icon: 'support_agent',
          title: '24/7 Support',
          description: 'Get help anytime with our dedicated support team and resources.'
        },
        {
          icon: 'security',
          title: 'Bank-Level Security',
          description: 'Your data is protected with enterprise-grade encryption and security.'
        },
        {
          icon: 'insights',
          title: 'Real-Time Analytics',
          description: 'Track performance metrics and optimize your strategy with live data.'
        }
      ]
    };
  },
  created() {
    // Check for subdomain and redirect to card if exists
    const subdomain = this.getSubdomain();
    if (subdomain) {
      // Redirect to card page with subdomain
      this.$router.push('/card');
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getSubdomain() {
      const hostname = window.location.hostname;
      const domainParts = hostname.split('.');

      // Assuming the domain is of the form subdomain.example.com
      // Exclude 'www' as a subdomain
      if (domainParts.length > 2 && domainParts[0] !== 'www') {
        return domainParts[0];
      } else {
        return null; // No subdomain
      }
    },
    handleScroll() {
      this.scrolled = window.scrollY > 50;
    },
    scrollToSection(sectionId) {
      this.drawer = false;
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    },
    goToLogin() {
      this.$router.push('/login');
    },
    joinFree() {
      this.$router.push('/homesync-agent-signup');
    },
    createAccount() {
      this.$router.push('/homesync-agent-signup');
    }
  }
};
</script>

<style scoped>
/* Global Styles */
* {
  box-sizing: border-box;
}

.homesync-landing {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  overflow-x: hidden;
}

/* Header Styles */
.homesync-header {
  z-index: 1000 !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-bottom: 1px solid transparent;
}

.homesync-header.scrolled {
  backdrop-filter: blur(20px) saturate(180%);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 82, 204, 0.1);
}

.logo-container {
  cursor: pointer;
}

.homesync-logo {
  transition: all 0.3s ease;
}

.homesync-logo:hover {
  transform: scale(1.05);
  filter: brightness(1.1);
}

.nav-link {
  font-weight: 500;
  letter-spacing: 0.3px;
  text-transform: none;
  font-size: 15px;
  transition: all 0.3s ease;
}

.nav-link:hover {
  transform: translateY(-2px);
}

.login-btn {
  border: 2px solid currentColor;
  font-weight: 600;
  text-transform: none;
  border-radius: 8px;
  padding: 0 24px !important;
  transition: all 0.3s ease;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 82, 204, 0.2);
}

.signup-btn {
  font-weight: 600;
  text-transform: none;
  border-radius: 8px;
  padding: 0 28px !important;
  transition: all 0.3s ease;
}

.signup-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 82, 204, 0.3);
}

/* Mobile Drawer */
.mobile-drawer {
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
}

.mobile-drawer .v-list-item {
  border-radius: 12px;
  margin: 4px 12px;
  transition: all 0.3s ease;
}

.mobile-drawer .v-list-item:hover {
  background: rgba(0, 82, 204, 0.05);
  transform: translateX(4px);
}

/* Hero Section */
.hero-section {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

.hero-background {
  position: relative;
  min-height: 100vh;
  background: linear-gradient(135deg, rgba(10, 25, 41, 0.65) 0%, rgba(13, 40, 71, 0.65) 50%, rgba(15, 52, 96, 0.65) 100%),
              url('~@/assets/img/bg-landing.png');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Animated Background */
.animated-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.grid-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
    linear-gradient(rgba(0, 82, 204, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 82, 204, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

.floating-house {
  position: absolute;
  opacity: 0.08;
  animation: float 20s ease-in-out infinite;
}

.floating-house i {
  font-size: 120px;
  color: #0052CC;
}

.house-1 {
  top: 15%;
  left: 10%;
  animation-delay: 0s;
}

.house-2 {
  top: 60%;
  right: 15%;
  animation-delay: 7s;
}

.house-3 {
  bottom: 20%;
  left: 20%;
  animation-delay: 14s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-30px) rotate(5deg);
  }
  50% {
    transform: translateY(-60px) rotate(0deg);
  }
  75% {
    transform: translateY(-30px) rotate(-5deg);
  }
}

.hero-content {
  position: relative;
  z-index: 2;
  padding-top: 140px;
  padding-bottom: 100px;
}

/* Hero Badge */
.hero-badge {
  display: inline-flex;
  align-items: center;
  padding: 10px 24px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  animation: pulse 2s ease-in-out infinite;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-badge i {
  font-size: 18px;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(0, 82, 204, 0.4);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(0, 82, 204, 0);
  }
}

.hero-title {
  font-size: 4rem;
  font-weight: 800;
  color: white;
  line-height: 1.15;
  letter-spacing: -1px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5),
               0 4px 12px rgba(0, 0, 0, 0.4),
               0 8px 24px rgba(0, 0, 0, 0.3);
}

@media (max-width: 960px) {
  .hero-title {
    font-size: 3rem;
  }
}

@media (max-width: 600px) {
  .hero-title {
    font-size: 2.2rem;
    letter-spacing: -0.5px;
  }

  .hero-content {
    padding-top: 120px;
    padding-bottom: 60px;
  }
}

.hero-subtitle {
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.7;
  font-weight: 400;
  max-width: 800px;
  margin: 0 auto;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.6),
               0 4px 16px rgba(0, 0, 0, 0.4);
}

@media (max-width: 600px) {
  .hero-subtitle {
    font-size: 1.05rem;
  }
}

.hero-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}

.join-btn,
.how-btn {
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: none;
  padding: 0 36px !important;
  height: 56px !important;
  border-radius: 12px;
  font-size: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.join-btn {
  background: linear-gradient(135deg, #0052CC 0%, #0066FF 100%) !important;
  box-shadow: 0 10px 30px rgba(0, 82, 204, 0.4);
}

.join-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(0, 82, 204, 0.5);
}

.how-btn {
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(10px);
}

.how-btn:hover {
  border-color: white !important;
  background: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-3px);
}

/* Trust Indicators */
.trust-indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  flex-wrap: wrap;
  margin-top: 60px;
}

.trust-item {
  text-align: center;
}

.trust-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: white;
  line-height: 1;
  margin-bottom: 8px;
}

.trust-label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

.trust-divider {
  width: 1px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
}

@media (max-width: 600px) {
  .trust-indicators {
    gap: 20px;
  }

  .trust-number {
    font-size: 2rem;
  }

  .trust-label {
    font-size: 0.8rem;
  }

  .trust-divider {
    display: none;
  }
}

/* Section Badges */
.section-badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 20px;
  background: rgba(0, 82, 204, 0.08);
  border: 1px solid rgba(0, 82, 204, 0.15);
  border-radius: 50px;
  color: #0052CC;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.section-badge i {
  font-size: 16px;
}

.section-title {
  font-size: 2.75rem;
  font-weight: 800;
  color: #1a1a2e;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

@media (max-width: 600px) {
  .section-title {
    font-size: 2rem;
  }
}

.section-subtitle {
  font-size: 1.15rem;
  color: #64748b;
  line-height: 1.7;
  max-width: 700px;
  margin: 0 auto;
}

/* How It Works Section */
.how-it-works-section {
  padding: 120px 0;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  position: relative;
}

.step-card {
  padding: 40px 20px;
  text-align: center;
  position: relative;
  z-index: 1;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.step-card:hover {
  transform: translateY(-10px);
}

.step-icon-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 30px;
}

.step-number-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #0052CC 0%, #0066FF 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 800;
  font-size: 16px;
  box-shadow: 0 4px 15px rgba(0, 82, 204, 0.4);
  z-index: 2;
}

.step-icon-circle {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, rgba(0, 82, 204, 0.1) 0%, rgba(0, 102, 255, 0.1) 100%);
  border: 2px solid rgba(0, 82, 204, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
}

.step-card:hover .step-icon-circle {
  background: linear-gradient(135deg, #0052CC 0%, #0066FF 100%);
  border-color: #0052CC;
  transform: scale(1.1);
  box-shadow: 0 10px 30px rgba(0, 82, 204, 0.3);
}

.step-icon-circle i {
  font-size: 48px;
  color: #0052CC;
  transition: all 0.4s ease;
}

.step-card:hover .step-icon-circle i {
  color: white;
  transform: scale(1.1);
}

.step-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 12px;
}

.step-description {
  font-size: 1rem;
  color: #64748b;
  line-height: 1.7;
  max-width: 300px;
  margin: 0 auto;
}

/* Features Section */
.features-section {
  padding: 120px 0;
  background: white;
}

.feature-card {
  padding: 32px 24px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 82, 204, 0.12);
  border-color: rgba(0, 82, 204, 0.3);
}

.feature-icon-wrapper {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, rgba(0, 82, 204, 0.1) 0%, rgba(0, 102, 255, 0.1) 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: all 0.4s ease;
}

.feature-card:hover .feature-icon-wrapper {
  background: linear-gradient(135deg, #0052CC 0%, #0066FF 100%);
  transform: scale(1.1) rotate(5deg);
}

.feature-icon-wrapper i {
  font-size: 32px;
  color: #0052CC;
  transition: all 0.4s ease;
}

.feature-card:hover .feature-icon-wrapper i {
  color: white;
}

.feature-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 12px;
}

.feature-description {
  font-size: 0.95rem;
  color: #64748b;
  line-height: 1.7;
}

/* Agents & Partners Sections */
.agents-section,
.partners-section {
  padding: 120px 0;
}

.agents-section {
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
}

.partners-section {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.section-title-left {
  font-size: 2.75rem;
  font-weight: 800;
  color: #1a1a2e;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

@media (max-width: 600px) {
  .section-title-left {
    font-size: 2rem;
  }
}

.section-description {
  font-size: 1.15rem;
  color: #64748b;
  line-height: 1.8;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  font-size: 1.05rem;
  color: #475569;
}

.feature-list i {
  color: #0052CC;
  font-size: 24px;
  flex-shrink: 0;
  margin-top: 2px;
}

/* Content Image Wrapper */
.content-image-wrapper {
  position: relative;
  height: 500px;
  border-radius: 24px;
  background: linear-gradient(135deg, rgba(0, 82, 204, 0.05) 0%, rgba(0, 102, 255, 0.05) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

@media (max-width: 960px) {
  .content-image-wrapper {
    height: 400px;
    margin-bottom: 40px;
  }
}

.image-decoration {
  position: absolute;
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, rgba(0, 82, 204, 0.1) 0%, rgba(0, 102, 255, 0.1) 100%);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.partner-decoration {
  background: linear-gradient(135deg, rgba(250, 197, 0, 0.1) 0%, rgba(255, 165, 0, 0.1) 100%);
}

.stats-card {
  position: relative;
  z-index: 2;
  background: white;
  padding: 32px;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: float 4s ease-in-out infinite;
  animation-delay: 1s;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 20px;
}

.stat-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #0052CC 0%, #0066FF 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon i {
  font-size: 28px;
  color: white;
}

.stat-value {
  font-size: 2.5rem;
  font-weight: 800;
  color: #1a1a2e;
  line-height: 1;
}

.stat-label {
  font-size: 0.95rem;
  color: #64748b;
  font-weight: 500;
  margin-top: 4px;
}

/* CTA Section */
.cta-section {
  padding: 120px 0;
  background: linear-gradient(135deg, #0a1929 0%, #0d2847 50%, #0f3460 100%);
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    linear-gradient(rgba(0, 82, 204, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 82, 204, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

.cta-card {
  position: relative;
  padding: 80px 60px;
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.3);
}

@media (max-width: 600px) {
  .cta-card {
    padding: 60px 30px;
  }
}

.cta-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: pulse 2s ease-in-out infinite;
}

.cta-icon i {
  font-size: 40px;
  color: white;
}

.cta-title {
  font-size: 3rem;
  font-weight: 800;
  color: white;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

@media (max-width: 600px) {
  .cta-title {
    font-size: 2rem;
  }
}

.cta-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.7;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.cta-btn {
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: none;
  padding: 0 40px !important;
  height: 56px !important;
  border-radius: 12px;
  font-size: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.primary-cta {
  color: black !important;
  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.2);
}

.primary-cta:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(255, 255, 255, 0.3);
}

.secondary-cta {
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
}

.secondary-cta:hover {
  border-color: white !important;
  background: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-3px);
}

/* CTA Trust Badges */
.cta-trust-badges {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
}

.trust-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  font-weight: 500;
}

.trust-badge i {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.9);
}

@media (max-width: 600px) {
  .cta-trust-badges {
    gap: 20px;
  }

  .trust-badge {
    font-size: 0.85rem;
  }
}

/* Footer */
.homesync-footer {
  background: #0a1929;
  color: rgba(255, 255, 255, 0.7);
  padding: 0;
}

.footer-description {
  font-size: 0.95rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.6);
  max-width: 300px;
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-link {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: rgba(0, 82, 204, 0.2);
  border-color: #0052CC;
  color: white;
  transform: translateY(-3px);
}

.social-link i {
  font-size: 20px;
}

.footer-heading {
  font-size: 1rem;
  font-weight: 700;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.footer-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-menu li {
  margin-bottom: 12px;
}

.footer-menu a,
.footer-menu .router-link-active,
.footer-menu .router-link-exact-active {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  display: inline-block;
}

.footer-menu a:hover,
.footer-menu .router-link-active:hover,
.footer-menu .router-link-exact-active:hover {
  color: white;
  transform: translateX(4px);
}

.footer-copyright {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.heart-icon {
  font-size: 14px;
  color: #ff4757;
  vertical-align: middle;
  animation: heartbeat 1.5s ease-in-out infinite;
}

@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* Responsive Utilities */
@media (max-width: 960px) {
  .agents-section,
  .partners-section,
  .how-it-works-section,
  .features-section {
    padding: 80px 0;
  }

  .cta-section {
    padding: 80px 0;
  }
}

@media (max-width: 600px) {
  .agents-section,
  .partners-section,
  .how-it-works-section,
  .features-section {
    padding: 60px 0;
  }

  .cta-section {
    padding: 60px 0;
  }

  .section-badge {
    font-size: 11px;
    padding: 6px 16px;
  }

  .section-subtitle {
    font-size: 1rem;
  }
}

/* Smooth Scrolling */
html {
  scroll-behavior: smooth;
}

/* Loading Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Accessibility */
.v-btn:focus {
  outline: 2px solid #0052CC;
  outline-offset: 2px;
}

/* Print Styles */
@media print {
  .homesync-header,
  .cta-section,
  .homesync-footer {
    display: none;
  }
}
</style>

